import React from 'react';

export const IncrementalModule = React.forwardRef( () => {
  return null;
} );


export const displayName = 'IncrementalModule';

IncrementalModule.displayName = displayName;

export default IncrementalModule;